import script from "./EscolhaFormulario.vue?vue&type=script&setup=true&lang=js"
export * from "./EscolhaFormulario.vue?vue&type=script&setup=true&lang=js"

import "./EscolhaFormulario.vue?vue&type=style&index=0&id=1f77be7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f77be7e"]])

export default __exports__